'use strict';

const DEFAULT_PARSER = {
    parse: value => null
};

const v1_1CloudDigitParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_1/digit/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_1/digit/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_1/digit/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_1/digit/params-report-parser"),
    // "DTU": 0xF6
    "ALARM": require("./mode/cloud/v1_1/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_1/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_1/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_1CloudAnalogParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_1/analog/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_1/analog/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_1/analog/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_1/analog/params-report-parser"),
    // "DTU": 0xF6
    "ALARM": require("./mode/cloud/v1_1/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_1/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_1/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_1CloudUartParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_1/uart/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_1/uart/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_1/uart/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_1/uart/params-report-parser"),
    "DTU": require("./mode/cloud/v1_1/uart/dtu-report-parser"),
    "ALARM": require("./mode/cloud/v1_1/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_1/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_1/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};

const v1_2CloudDigitParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_2/digit/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_2/digit/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_2/digit/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_2/digit/params-report-parser"),
    // "DTU": 0xF6
    "ALARM": require("./mode/cloud/v1_2/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_2/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_2/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_2CloudAnalogParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_2/analog/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_2/analog/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_2/analog/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_2/analog/params-report-parser"),
    // "DTU": 0xF6
    "ALARM": require("./mode/cloud/v1_2/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_2/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_2/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_2CloudUartParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_2/uart/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_2/uart/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_2/uart/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_2/uart/params-report-parser"),
    "DTU": require("./mode/cloud/v1_2/uart/dtu-report-parser"),
    "ALARM": require("./mode/cloud/v1_2/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_2/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_2/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};

const v1_3CloudDigitParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_3/digit/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_3/digit/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_3/digit/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_3/digit/params-report-parser"),
    // "DTU": 0xF6
    "ALARM": require("./mode/cloud/v1_3/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_3/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_3/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_3CloudAnalogParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_3/analog/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_3/analog/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_3/analog/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_3/analog/params-report-parser"),
    // "DTU": 0xF6
    "ALARM": require("./mode/cloud/v1_3/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_3/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_3/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_3CloudUartParser = {
    // "COMMON": 0xF1,
    "CHANGE": require("./mode/cloud/v1_3/uart/change-report-parser"),
    "ATTRIBUTE": require("./mode/cloud/v1_3/uart/attribute-report-parser"),
    "REGULAR": require("./mode/cloud/v1_3/uart/regular-report-parser"),
    "PARAMS": require("./mode/cloud/v1_3/uart/params-report-parser"),
    "DTU": require("./mode/cloud/v1_3/uart/dtu-report-parser"),
    "ALARM": require("./mode/cloud/v1_3/common/alarm-parser"),
    "RULE": require("./mode/cloud/v1_3/common/rule-parser-factory"),
    "INTELLIGENCE": require("./mode/cloud/v1_3/common/intelligence-report-parser"),
    "RESTART": DEFAULT_PARSER,
};

const v1_1LoRaDigitParser = {
    "CHANGE": require("./mode/lora/v1_1/digit/change-report-parser"),
    "ATTRIBUTE": require("./mode/lora/v1_1/digit/attribute-report-parser"),
    "REGULAR": require("./mode/lora/v1_1/digit/regular-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_1LoRaAnalogParser = {
    "CHANGE": require("./mode/lora/v1_1/analog/change-report-parser"),
    "ATTRIBUTE": require("./mode/lora/v1_1/analog/attribute-report-parser"),
    "REGULAR": require("./mode/lora/v1_1/analog/regular-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_1LoRaUartParser = {
    "CHANGE": require("./mode/lora/v1_1/uart/change-report-parser"),
    "ATTRIBUTE": require("./mode/lora/v1_1/uart/attribute-report-parser"),
    "REGULAR": require("./mode/lora/v1_1/uart/regular-report-parser"),
    "RESTART": DEFAULT_PARSER,
};

const v1_2LoRaDigitParser = {
    "CHANGE": require("./mode/lora/v1_2/digit/change-report-parser"),
    "ATTRIBUTE": require("./mode/lora/v1_2/digit/attribute-report-parser"),
    "REGULAR": require("./mode/lora/v1_2/digit/regular-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_2LoRaAnalogParser = {
    "CHANGE": require("./mode/lora/v1_2/analog/change-report-parser"),
    "ATTRIBUTE": require("./mode/lora/v1_2/analog/attribute-report-parser"),
    "REGULAR": require("./mode/lora/v1_2/analog/regular-report-parser"),
    "RESTART": DEFAULT_PARSER,
};
const v1_2LoRaUartParser = {
    "CHANGE": require("./mode/lora/v1_2/uart/change-report-parser"),
    "ATTRIBUTE": require("./mode/lora/v1_2/uart/attribute-report-parser"),
    "REGULAR": require("./mode/lora/v1_2/uart/regular-report-parser"),
    "RESTART": DEFAULT_PARSER,
};

const v1_1CloudDevice = {
    "DIGIT": v1_1CloudDigitParser,
    "ANALOG": v1_1CloudAnalogParser,
    "UART": v1_1CloudUartParser
};
const v1_2CloudDevice = {
    "DIGIT": v1_2CloudDigitParser,
    "ANALOG": v1_2CloudAnalogParser,
    "UART": v1_2CloudUartParser
};
const v1_3CloudDevice = {
    "DIGIT": v1_3CloudDigitParser,
    "ANALOG": v1_3CloudAnalogParser,
    "UART": v1_3CloudUartParser
};

const v1_1LoRaDevice = {
    "DIGIT": v1_1LoRaDigitParser,
    "ANALOG": v1_1LoRaAnalogParser,
    "UART": v1_1LoRaUartParser
};
const v1_2LoRaDevice = {
    "DIGIT": v1_2LoRaDigitParser,
    "ANALOG": v1_2LoRaAnalogParser,
    "UART": v1_2LoRaUartParser
};

const v1IPSOT1Parser = {
    "*": require("./mode/ipso/v1/t1"),
};
const v1IPSON1Parser = {
    "*": require("./mode/ipso/v1/n1"),
};

const v1IPSO11Parser = {
    "*": require("./mode/ipso/v1/11"),
};

const v1IPSODevice = {
    "t1": v1IPSOT1Parser,
    "n1": v1IPSON1Parser,
    "11": v1IPSO11Parser,
};

const cloud = {
    "v1.1": v1_1CloudDevice,
    "v1.2": v1_2CloudDevice,
    "v1.3": v1_3CloudDevice,
};
const lora = {
    "v1.1": v1_1LoRaDevice,
    "v1.2": v1_2LoRaDevice,
};
const ipso = {
    "v1": v1IPSODevice,
};

const Mode = {
    "cloud": cloud,
    "lora": lora,
    "ipso": ipso,
};


function getParser(ver, deviceType, packageType, mode) {
    let m = Mode[mode];
    if (!m) {
        throw new Error("No handler for such mode!");
    }
    let v = m[ver];
    if (!v) {
        throw new Error("No handler for such version!");
    }
    let d = v[deviceType];
    if (!d) {
        throw new Error("No handler for such device type!");
    }
    let parser = d[packageType];
    if (!parser) {
        throw new Error("No handler for such package type!");
    }
    return parser;
}

module.exports.getParser = getParser;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/ucp-parser-factory.js